<template>
  <div>
    <InvoiceExcelImport ref="import" v-on:uploaded="fileUpload" />
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        {{ $t("faturamento") }}
        <el-form style="float: right; padding: 3px 0" :inline="true">
          <el-button type="info" plain @click="$refs.import.open()">Importar planilha</el-button>
        </el-form>
      </div>
      <el-form style="padding: 3px 0" :inline="true">
        <el-form-item :label="$t('periodo')" prop="month">
          <MonthList ref="month" :quantity="12" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="fetch">Visualisar</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <DashboardBilletTotal ref="total" :month="month" />
    </el-card>
  </div>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import InvoiceExcelImport from "./InvoiceExcelImport.vue";
import { DashboardService } from "@/services/customers/dashboard.services";
import MonthList from "./MonthList.vue";
import DashboardBilletTotal from './components/DashboardBilletTotal';

export default {
  name: "InvoiceExcelDashboard",
  components: {
    InvoiceExcelImport,
    MonthList,
    DashboardBilletTotal,
  },
  data() {
    return {
      tableData: [],
      month: '',
      userType: "1",
    };
  },
  methods: {
    fileUpload(id, event = true) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      AuditService.findfile(id)
        .then((response) => {
          const index = vm.tableData.findIndex(x => x.id === id);
          if (index === -1) {
            vm.tableData.unshift(response)
          } else {
            vm.tableData.splice(index, 1);
            vm.tableData.unshift(response);
          }
          if (event) {
            vm.$bus.$emit("audit", id);
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetch() {
      const vm = this;
      vm.tableData = [];
      vm.month = vm.$refs.month.get();
      setTimeout(() => {
        vm.$refs.total.fetch();

      }, 200)
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-upload--text {
  width: 100%;
}

.el-upload--text {
  width: 100%;
}
</style>